import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import { compose, graphql } from 'react-apollo';
import PropTypes from 'prop-types';

import EnvironmentForm from 'components/applications/environment-modifier/environment-form';
import gqlMutCreateEnv from 'graphql/mutations/create-environment';
import Loader from 'components/theme/loader';
import SnackBar from 'components/theme/snackbar';

class EnvironmentModifier extends Component {
  state = { loading: false, error: null, completed: false };

  handleClose = () => {
    this.props.onClose();
  };

  onSubmit = (values) => {
    this.setState({ loading: true, error: null, completed: false });

    let graphqlAction;
    const { appId } = this.props;
    if (this.props.action === 'add') {
      graphqlAction = this.props.mutateCreateEnv({
        variables: {
          name: values.name,
          appId
        }
      });
    }

    graphqlAction
      .then(() => {
        this.setState({ completed: true });
      })
      .catch((error) => {
        this.setState({ error });
      })
      .finally(() => {
        this.handleClose();
        this.setState({ loading: false }, this.resetState);
      });
  };

  resetState() {
    this.setState({ loading: false, error: null, completed: false });
  }

  render() {
    const { open, action, ...restProps } = this.props;
    const { loading, error, completed } = this.state;

    if (loading) return <Loader />;

    if (error) {
      console.warn(error);
      return null;
    }

    if (completed) {
      const messageContext = action === 'add' ? 'added' : 'updated';
      return (
        <SnackBar
          message={`Environment is ${messageContext} successfully!`}
          options={{ variant: 'success' }}
        />
      );
    }

    return (
      <Dialog
        open={open}
        onClose={this.handleClose}
        aria-labelledby="form-dialog-title"
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="form-dialog-title">
          {action === 'add' ? 'Add' : 'Update'} environment
        </DialogTitle>
        <EnvironmentForm
          onClose={this.handleClose}
          onSubmit={this.onSubmit}
          action={action}
          {...restProps}
        />
      </Dialog>
    );
  }
}

EnvironmentModifier.propTypes = {
  open: PropTypes.bool.isRequired
};

export default compose(
  graphql(gqlMutCreateEnv, {
    name: 'mutateCreateEnv',
    options: () => {
      return {
        awaitRefetchQueries: true,
        refetchQueries: ['listEnvironments']
      };
    }
  })
)(EnvironmentModifier);
